import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c45f82e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tenantLabel" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "appName"
}

import { computed, ComputedRef } from 'vue';

import Tenant from '@/data/datatypes/Tenant';
import { patternForApp } from '@/data/helpers/TaskHelper';
import { AppIdentDetails, MiniApp } from '@/data/tasks/MiniApp';

interface Props {
  userTenantId?: string;
  app: MiniApp | AppIdentDetails;
  tenants: Record<string, Tenant>;
  showAppName?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppIdent',
  props: {
    userTenantId: {},
    app: {},
    tenants: {},
    showAppName: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const needsDefaultIdent: ComputedRef<boolean> = computed(() => {
  return !('pattern' in props.app);
});

const styleForApp: ComputedRef<Record<string, string> | undefined> = computed(() => {
  // The check for 'id' is to separate the behaviour for the 2 classes of psudo-app;
  // the old collaborate app and the psudo-apps in the calendar. It's possible for the
  // MiniApp to have an 'id' but not a 'pattern' E.g. the internal collab app, in which case
  // a pattern is derived from the object's properties.
  if ('id' in props.app || 'pattern' in props.app) {
    return {
      background: patternForApp(props.app as MiniApp).gradient
    };
  }
  return undefined;
});

const isExternalTenantApp: ComputedRef<boolean> = computed(() => {
  return !!props.app.tenantId && !!props.userTenantId && props.app.tenantId !== props.userTenantId;
});

function tenantName(tenantId: string, tenants: Record<string, Tenant>, verbose: boolean = false): string {
  const tenantName: string = tenants[tenantId]?.name ?? 'External tenant';
  return verbose ? `This App is shared from another tenant:\n${tenantName}` : tenantName;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ident", { cafexBackground: needsDefaultIdent.value }]),
    style: _normalizeStyle(styleForApp.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", { externalTenant: isExternalTenantApp.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (isExternalTenantApp.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" from "),
              _createElementVNode("span", {
                class: "name",
                title: tenantName(_ctx.app.tenantId, _ctx.tenants, true)
              }, _toDisplayString(tenantName(_ctx.app.tenantId, _ctx.tenants)), 9, _hoisted_2)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showAppName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.app.name), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 6))
}
}

})